
export function getParameterByName (name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


export function getParameters (url) {
	if (!url) url = window.location.search;

	if (url.length < 2) return [];

	let params = url.split("?")[1].split("&");

	let list = [];
	for (let i=0; i<params.length; i++){
		const par = params[i].split("=");
		list[par[0]] = par[1];
	}
	
	return list;
}

export default {getParameterByName, getParameters}
